// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1Rsgh","list":"PatternAutocomplete_list__z7bAN"};